import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLanguageFromPath } from '../../lib/utils/geolocation';

export function StructuredData() {
  const location = useLocation();
  const { t } = useTranslation();
  const currentLang = getLanguageFromPath(location.pathname) || 'en';

  useEffect(() => {
    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Create new structured data
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": t('seo.title'),
      "description": t('seo.description'),
      "url": currentLang === 'en' 
        ? `https://broilerfcr.com${location.pathname}`
        : `https://broilerfcr.com/tr${location.pathname === '/tr' ? '' : location.pathname.replace('/tr', '')}`,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web Browser",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "author": {
        "@type": "Organization",
        "name": "Broiler FCR System"
      },
      "inLanguage": currentLang,
      "audience": {
        "@type": "Audience",
        "audienceType": "Farmers, Poultry Producers, Agricultural Businesses"
      },
      "featureList": [
        "FCR Calculation",
        "Production Tracking", 
        "Expense Management",
        "Performance Metrics",
        "Multi-language Support",
        "Multi-currency Support"
      ]
    };

    // Add structured data to head
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      // Cleanup on unmount
      const scriptToRemove = document.querySelector('script[type="application/ld+json"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [location.pathname, currentLang, t]);

  return null;
}